@if (control) {
  <div class="u-relative">
    @if (config.icon) {
      <div class="form-control__icon">
        <icon [name]="config.icon" [config]="{ fill: 'fc-icon-color' }"> </icon>
      </div>
    }
    <!--
    Custom input option is exposed to allow higher-level components access to the native input element
    while preserving reusability of form-control components label/error/etc. templating.
    Examples include custom form components that implement ControlValueAccessor that need the native input
    -->
    @if (customInputTemplate) {
      <ng-container *ngTemplateOutlet="customInputTemplate"></ng-container>
    } @else {
      @if (!config.mask) {
        <input
          class="form-control"
          [ngClass]="{ 'form-control--icon-right': config.iconRight }"
          tabindex="0"
          (focusout)="focusOutEvent.emit($event)"
          (focus)="focusEvent.emit($event)"
          #input
          ngDefaultControl
          (keydown)="
            (config.type === 'number'
              ? $event.key !== 'e' && $event.key !== 'E'
              : true)
          "
          [readOnly]="config.readonly"
          [attr.readonly]="config?.isDisabled ? config?.isDisabled : null"
          [attr.aria-label]="config.ariaLabel"
          [attr.aria-invalid]="
            (control.dirty || control.touched) && !control.valid
          "
          [attr.aria-required]="
            config?.validators && config?.validators.includes('required')
              ? true
              : false
          "
          [attr.autocomplete]="autocomplete !== null ? autocomplete : true"
          [attr.placeholder]="config.placeholder ? config.placeholder : null"
          [attr.type]="config.type"
          [attr.max]="
            config.type === 'date' ? config.max || '9999-01-01' : null
          "
          [attr.min]="config.type === 'date' ? config.min || '' : null"
          [formControl]="control"
          [id]="config.id || config.prop"
          [maxlength]="config.maxLength || ''"
          [name]="config.prop || config.name"
          (input)="onInputChange()"
        />
      } @else {
        <input
          class="form-control"
          [ngClass]="{ 'form-control--icon-right': config.iconRight }"
          tabindex="0"
          (focusout)="focusOutEvent.emit($event)"
          (focus)="focusEvent.emit($event)"
          #input
          [zipMask]="config.mask"
          [attr.readonly]="config?.isDisabled ? config?.isDisabled : null"
          [readonly]="config.readonly || control.disabled"
          [attr.aria-label]="config.ariaLabel"
          [attr.aria-invalid]="
            (control.dirty || control.touched) && !control.valid
          "
          [attr.aria-required]="
            config?.validators && config?.validators.includes('required')
              ? true
              : false
          "
          [attr.autocomplete]="autocomplete !== null ? autocomplete : true"
          [attr.placeholder]="config.placeholder ? config.placeholder : null"
          [attr.max]="
            config.type === 'date' ? config.max || '9999-01-01' : null
          "
          type="tel"
          [formControl]="control"
          [id]="config.id || config.prop"
          [maxlength]="config.maxLength || ''"
          [name]="config.prop || config.name"
          (input)="onInputChange()"
        />
      }
    }
    @if (config.unit) {
      <div class="form-control__icon form-control__icon--right">
        <p class="t-data t-alt">{{ config.unit }}</p>
      </div>
    }
    @if (config.iconRight) {
      <div class="form-control__icon form-control__icon--right">
        <icon [name]="config.iconRight" [config]="{ fill: 'fc-icon-color' }">
        </icon>
      </div>
    }
    @if (
      config.remainingCount && config.maxLength > 0 && control.value?.length
    ) {
      <span class="form-control-textarea__remaining-characters">
        {{ config.maxLength - control.value.length }} characters remaining
      </span>
    }
  </div>
}
